import { useEffect, useState } from "react";

// Cycles through an index on an interval, mirroring the mockup's
// BE SEEN / BE HEARD / BE HIRED rotator.
const useKeywordRotator = (count: number, intervalMs = 2400) => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((current) => (current + 1) % count);
    }, intervalMs);
    return () => clearInterval(timer);
  }, [count, intervalMs]);

  return activeIndex;
};

export default useKeywordRotator;
